<template>
  <page>
    <form data-vv-scope="ComVoucherForm">
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-sm>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-text-field
                        v-model="comVoucherForm.comAcctNo"
                        :label="comVoucherLabel.comAcctNo"
                        :error-messages="errors.collect('comVoucherForm.comAcctNo')"
                        data-vv-name="comVoucherForm.comAcctNo"
                        :data-vv-as="comVoucherLabel.comAcctNo"
                        v-validate="'required'"
                      >
                        <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                          <v-icon color="info" @click="showInterHelpList = true" v-text="'mdi-magnify'"></v-icon>
                        </v-slide-x-reverse-transition>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6> </v-flex>
                    <v-flex xs6>
                      <cal-picker
                        v-model="comVoucherForm.tranDateFrom"
                        :label="comVoucherLabel.tranDateFrom"
                        :data-vv-as="comVoucherLabel.tranDateFrom"
                        data-vv-name="comVoucherForm.tranDateFrom"
                        :error-messages="errors.collect('comVoucherForm.tranDateFrom')"
                        v-validate="tranDateFromValidation"
                      ></cal-picker>
                    </v-flex>
                    <v-flex xs6>
                      <cal-picker
                        v-model="comVoucherForm.tranDateTo"
                        :label="comVoucherLabel.tranDateTo"
                        :data-vv-as="comVoucherLabel.tranDateTo"
                        data-vv-name="comVoucherForm.tranDateTo"
                        :error-messages="errors.collect('comVoucherForm.tranDateTo')"
                        v-validate="tranDateToValidation"
                      ></cal-picker>
                    </v-flex>
                    <v-flex xs6>
                      <v-autocomplete
                        :items="comTypes"
                        v-model="comVoucherForm.comType"
                        :label="comVoucherLabel.comType"
                        item-text="label"
                        item-value="value"
                        data-vv-name="comVoucherForm.comType"
                        :data-vv-as="comVoucherLabel.comType"
                        :error-messages="errors.collect('comVoucherForm.comType')"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs6>
                      <cal-picker
                        v-model="comVoucherForm.matchRecordAt"
                        :label="comVoucherLabel.matchRecordAt"
                        :data-vv-as="comVoucherLabel.matchRecordAt"
                        data-vv-name="comVoucherForm.matchRecordAt"
                        :error-messages="errors.collect('comVoucherForm.matchRecordAt')"
                        v-validate="matchDateValidation"
                      ></cal-picker>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        v-model="comVoucherForm.branch"
                        :label="comVoucherLabel.branch"
                        :error-messages="errors.collect('comVoucherForm.branch')"
                        data-vv-name="comVoucherForm.branch"
                        :data-vv-as="comVoucherLabel.branch"
                        append-icon="mdi-magnify"
                        @click:append="getHelpList('branch')"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        v-model="comVoucherForm.currency"
                        :label="comVoucherLabel.currency"
                        :error-messages="errors.collect('comVoucherForm.currency')"
                        data-vv-name="comVoucherForm.currency"
                        :data-vv-as="comVoucherLabel.currency"
                        v-validate="'required'"
                      >
                        <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                          <v-icon color="info" @click="showCurrencyHelpList = true" v-text="'mdi-magnify'"></v-icon>
                        </v-slide-x-reverse-transition>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        v-model="comVoucherForm.excludeAcctNoSfx"
                        :label="comVoucherLabel.excludeAcctNoSfx"
                        :error-messages="errors.collect('comVoucherForm.excludeAcctNoSfx')"
                        data-vv-name="comVoucherForm.excludeAcctNoSfx"
                        :data-vv-as="comVoucherLabel.excludeAcctNoSfx"
                        append-icon="mdi-magnify"
                        @click:append="getHelpList('suffix')"
                        readonly
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-dialog v-model="showErrorDialog" width="800px">
                    <v-card>
                      <v-card-title primary-title>
                        <div>
                          <div class="headline">System Information</div>
                          <span class="grey--text">An error occurred.</span>
                        </div>
                      </v-card-title>
                      <v-card-text>
                        <div v-if="messages.length > 0" class="pb-3">
                          <v-subheader>Error Details:</v-subheader>
                          <ul class="showErrorMsgs">
                            <li v-for="(error, index) in messages" :key="index">
                              {{ error.message }}
                            </li>
                          </ul>
                        </div>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-flex xs12>
          <v-btn class="mr-2" color="error" dark @click.prevent="doCancel">
            {{ actionLabel.cancel }}
            <v-icon dark right>mdi-exit-to-app</v-icon>
          </v-btn>
          <v-btn color="primary" dark @click.prevent="doSubmit" :loading="submitting">
            {{ actionLabel.submit }}
            <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
          </v-btn>
        </v-flex>
      </v-container>
    </form>

    <v-dialog v-model="showInterHelpList" width="1280px">
      <intermediary-help-list @close="showInterHelpList = false" @assign-acct-no="assignAcctNo"></intermediary-help-list>
    </v-dialog>

    <v-dialog v-model="helplist" width="900px" persistent>
      <helplist :apiURI="apiURI" :mode="mode" :param="param" @close="doClose" @doAssign="doAssign($event)"></helplist>
    </v-dialog>

    <v-dialog v-model="showCurrencyHelpList" width="1280px">
      <cr-currency-help-list @close="showCurrencyHelpList = false" @assign-currency="assignCurr"></cr-currency-help-list>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import IntermediaryHelpList from './IntermediaryHelpList'
import Helplist from '@/components/reports/accounts/Helplist'
import CrCurrencyHelpList from '@/components/core/common/dialog/CrCurrencyHelpList'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      comVoucherLabel: {
        comAcctNo: 'For Accounts Commission No.',
        tranDateFrom: 'Transaction Date',
        tranDateTo: 'To',
        comType: 'Commission Type',
        matchRecordAt: 'Match record as at',
        branch: 'Branch',
        currency: 'Currency',
        excludeAcctNoSfx: 'Exclude Account No Suffix',
        comTypes: 'Commission Type'
      },
      comVoucherForm: {
        comAcctNo: null,
        tranDateFrom: null,
        tranDateTo: null,
        comType: null,
        matchRecordAt: null,
        branch: 'All',
        currency: null,
        excludeAcctNoSfx: 'None',
        comTypes: null
      },
      actionLabel: {
        cancel: 'Cancel',
        submit: 'Submit'
      },
      comTypes: [
        { label: 'C - Commission', value: 'C' },
        { label: 'O - Overriding', value: 'O' }
      ],
      showInterHelpList: false,
      showCurrencyHelpList: false,
      helplist: false,
      apiURI: '',
      param: '',
      menu: {},
      mode: '',
      loading: false,
      submitting: false,
      showErrorDialog: false
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('comVoucherInit')])
      this.comVoucherForm.comType = 'C'
      this.comVoucherForm.tranDateFrom = new Date()
      this.comVoucherForm.tranDateTo = new Date()
      this.getCompany()
    },
    async getCompany() {
      const apiURI = this.comVoucherMenu.getCompany
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.comVoucherForm.currency = data.company.currency
        }
      }
    },
    assignAcctNo(data) {
      this.comVoucherForm.comAcctNo = data
      this.showInterHelpList = false
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      if (fieldName === 'branch') {
        this.apiURI = this.comVoucherMenu.getBranchList
        this.param = this.comVoucherForm.branch
      } else if (fieldName === 'suffix') {
        this.apiURI = this.comVoucherMenu.getAcctNoSfxList
        this.param = this.comVoucherForm.excludeAcctNoSfx
      }
      this.helplist = true
    },
    doClose() {
      this.helplist = false
    },
    doAssign(Obj) {
      switch (this.mode) {
        case 'branch':
          this.comVoucherForm.branch = ''
          this.comVoucherForm.branch = Obj.finalSelectedItems.toString()
          break
        case 'suffix':
          this.comVoucherForm.excludeAcctNoSfx = 'None'
          if (Obj.finalSelectedItems.length === 0) {
            this.comVoucherForm.excludeAcctNoSfx = 'None'
          } else {
            this.comVoucherForm.excludeAcctNoSfx = Obj.finalSelectedItems.toString()
          }
          break
      }
    },
    assignCurr(data) {
      this.comVoucherForm.currency = data
      this.showCurrencyHelpList = false
    },
    doCancel() {
      this.$router.push({ name: 'specFuncAcct' })
    },
    doSubmit() {
      this.$validator.validateAll('ComVoucherForm').then((result) => {
        if (result) {
          this.valAcctNo(this.comVoucherForm).then((result) => {
            if (result) {
              this.doProcess()
            }
          })
        }
      })
    },
    async valAcctNo(dataValue) {
      const apiUrl = this.$store.state.specFuncAcct.comVoucher.menu.valAcctNo
      if (apiUrl) {
        try {
          const params = {
            accountNo: dataValue.comAcctNo
          }
          const result = await this.$http.get(expandURI(apiUrl, params))
          const { data } = result.data
          if (data) {
            return true
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
          return false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    async doProcess() {
      const apiURI = this.$store.state.specFuncAcct.comVoucher.menu.doProcess
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.comVoucherForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('valDate', {
      getMessage(field, args) {
        return 'Record as at must be earlier or equals to System Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var matchDate = args[0]
        if (matchDate) {
          return !isAfter(removeTime(value), removeTime(matchDate))
        }
      }
    })

    this.$validator.extend('valTranDateFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranFromDate = args[0]
        if (tranFromDate) {
          return !isAfter(removeTime(value), removeTime(tranFromDate))
        }
      }
    })

    this.$validator.extend('valTranDateTo', {
      getMessage(field, args) {
        return 'To Date must be greater or equal to From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranToDate = args[0]
        if (tranToDate) {
          return !isAfter(removeTime(tranToDate), removeTime(value))
        }
      }
    })
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.accountReports.menu
    },
    comVoucherMenu() {
      return this.$store.state.specFuncAcct.comVoucher.menu
    },
    matchDateValidation() {
      if (this.comVoucherForm.matchRecordAt !== '' && this.comVoucherForm.matchRecordAt !== null) {
        return 'entry|valDate:' + new Date()
      } else {
        return 'required'
      }
    },
    tranDateFromValidation() {
      if (this.comVoucherForm.tranDateFrom !== '' && this.comVoucherForm.tranDateFrom !== null) {
        return 'entry|valTranDateFrom:' + this.comVoucherForm.tranDateTo
      } else {
        return 'required'
      }
    },
    tranDateToValidation() {
      if (this.comVoucherForm.tranDateTo !== '' && this.comVoucherForm.tranDateTo !== null) {
        return 'entry|valTranDateTo:' + this.comVoucherForm.tranDateFrom
      } else {
        return 'required'
      }
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  mixins: [MessageMixin],
  components: {
    IntermediaryHelpList,
    Helplist,
    CrCurrencyHelpList
  }
}
</script>
